export default __webpack_public_path__ + "static/media/logo-white.6a1463f8.png";